










































































































































































































































































import {
	computed,
	defineComponent,
	ref,
	watch,
} from '@vue/composition-api';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import RadioButton from '@front-app/components/inputs/RadioButton.vue';
import RichTextSection from '@front-app/components/form/RichTextSection.vue';
import ScrollingColumn from '@front-app/components/layouts/columns/ScrollingColumn.vue';
import SelectBox from '@front-app/components/inputs/SelectBox.vue';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import StandardErrorText from '@front-app/components/cards/state/StandardErrorText.vue';
import TrCheckbox from '@front-app/components/inputs/Checkbox.vue';
import TrSnackbar from '@front-app/components/Snackbar.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import { Routes } from '@front-app/constants/routes';
import { Size } from '@front-app/components/constants';
import { syncedRef } from '@front-app/util/reactivity';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { useEventAdminStore } from '@front-app/modules/event/store/EventAdmin';
import { getAvailableGroups } from '@front-app/modules/event/util/eventGroups';
import { VisibilityOption } from '@front-app/services/GroupsApi/GroupEvent';

export default defineComponent({
	components: {
		ColumnContainer,
		CtaButton,
		LoaderState,
		PaddedContent,
		RadioButton,
		RichTextSection,
		ScrollingColumn,
		SelectBox,
		SimpleCard,
		StandardErrorText,
		TrCheckbox,
		TrSnackbar,
	},
	props: {
		eventId: {
			type: String,
			required: true,
		},
	},
	setup(props, ctx) {
		const eventAdminStore = useEventAdminStore();
		const adminEvent = computed(() => eventAdminStore.getById(props.eventId));

		// Publishing
		const publishStatus = useAsyncStatus();
		const isPublished = computed(() => Boolean(adminEvent.value?.isPublished));
		const togglePublish = () => {
			if (!adminEvent.value) {
				return;
			}
			publishStatus.track(eventAdminStore.update(props.eventId, { isPublished: !isPublished.value }));
		};
		// END publishing

		// Registration
		const registrationStatus = useAsyncStatus();
		const isRegistrationEnabled = computed(() => Boolean(adminEvent.value?.allowRegistration));
		const toggleRegistration = () => {
			if (!adminEvent.value) {
				return;
			}
			registrationStatus.track(eventAdminStore.update(props.eventId, { allowRegistration: !isRegistrationEnabled.value }));
		};
		// END Registration

		// Terms of use
		const termsStatus = useAsyncStatus();
		const termsEnabled = syncedRef(() => Boolean(adminEvent.value?.termsEnabled)).ref;
		const requireTermsAcceptance = syncedRef(() => Boolean(adminEvent.value?.requireTermsAcceptance)).ref;
		const termsText = ref(adminEvent.value?.termsAndConditions);
		const haveTermsChanged = ref(false);
		watch(() => [props.eventId, termsText.value, termsEnabled.value], (curr, prev) => {
			if (curr[0] !== prev[0]) {
				haveTermsChanged.value = false;
			} else if (curr[1] === prev[1]) {
				haveTermsChanged.value = true;
			} else if (curr[2] === prev[2]) {
				haveTermsChanged.value = true;
			}
			termsStatus.clear(0);
		});
		const updateTerms = async () => {
			try {
				await termsStatus.track(eventAdminStore.update(props.eventId, {
					termsEnabled: termsEnabled.value,
					requireTermsAcceptance: requireTermsAcceptance.value,
					termsAndConditions: termsText.value,
				}));
				haveTermsChanged.value = false;
			} catch (e) {
				// empty
			}
		};
		// END Terms of use

		// Visibility
		const selectedVisibility = syncedRef(() => adminEvent.value?.visibility).ref;
		const isSelectedVisibility = (target: VisibilityOption): boolean => target === selectedVisibility.value;

		const visibilityStatus = useAsyncStatus();
		const setVisibility = (target: VisibilityOption) => {
			selectedVisibility.value = target;
			visibilityStatus.track(eventAdminStore.update(props.eventId, {
				visibility: selectedVisibility.value,
			}));
		};

		const isCopyLinkMenuOpen = ref(false);
		const showCopyLinkConfirmation = ref(false);

		const copyEventUrl = (groupId: string) => {
			if (!adminEvent.value) {
				return;
			}
			const route = ctx.root.$router.resolve({
				name: Routes.GROUP_EVENT,
				params: {
					eventId: props.eventId,
					groupId,
				},
			});
			const eventUrl = new URL(route.href, window.location.href).href;
			navigator.clipboard.writeText(eventUrl);
			showCopyLinkConfirmation.value = true;
			setTimeout(() => {
				showCopyLinkConfirmation.value = false;
			}, 5000);
		};

		const groupChoices = computed(() => getAvailableGroups(adminEvent.value));
		const selectedGroupId = ref('');
		const selectGroup = (groupId: string) => {
			selectedGroupId.value = groupId;
			copyEventUrl(groupId);
		};
		// END Visibility

		return {
			adminEvent,
			// Publish
			isPublished,
			publishStatus,
			togglePublish,
			// Registration
			isRegistrationEnabled,
			toggleRegistration,
			registrationStatus,
			// Terms of use
			termsStatus,
			termsEnabled,
			termsText,
			requireTermsAcceptance,
			haveTermsChanged,
			updateTerms,
			// Visibility
			VisibilityOption,
			isSelectedVisibility,
			setVisibility,
			visibilityStatus,
			groupChoices,
			selectedGroupId,
			selectGroup,
			isCopyLinkMenuOpen,
			copyEventUrl,
			showCopyLinkConfirmation,
			// Util
			ButtonPalettes,
			DropdownPosition,
			Size,
		};
	},
});
